import React from 'react';
import { 
  DialogTitle, 
  IconButton, 
  Typography, 
  Box, 
  Stack,
  useTheme 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

const ModalHeader = ({ id, title, onClose }) => {
  const theme = useTheme();

  return (
    <DialogTitle 
      component="div" 
      sx={{ 
        p: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
          p: theme.spacing(2),
        },
        borderBottom: `1px solid ${theme.palette.divider}`,
        background: theme.palette.background.default,
        backgroundColor: theme.palette.grey[200]
      }}
    >
      <Stack 
        direction="row" 
        justifyContent="space-between" 
        alignItems="center" 
        spacing={2}
      >
        <Box>
          {id && (
            <Typography 
              variant="h6" 
              component="h2" 
              sx={{ 
                fontWeight: 600,
                color: theme.palette.text.primary
              }}
            >
              {id}
            </Typography>
          )}
          
          {title && (
            <Typography 
              variant={ id ? "subtitle2" : "h6" } 
              color={ id ? "text.secondary" : theme.palette.text.primary }
              sx={{ mt: 0.5 }}
            >
              {title}
            </Typography>
          )}
        </Box>

        {onClose && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            size="small"
            edge="end"
            sx={{
              color: theme.palette.grey[500],
              transition: theme.transitions.create('all', {
                duration: theme.transitions.duration.shorter,
              }),
              '&:hover': {
                color: theme.palette.text.primary,
                background: theme.palette.action.hover,
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Stack>
    </DialogTitle>
  );
};

ModalHeader.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  onClose: PropTypes.func,
};

export default ModalHeader;